// todo: needs implementation, now available in api
export const CONTACTS_ROUTES = {
  __ROOT__: '/contacts',
}
